// extracted by mini-css-extract-plugin
export default {"appContainer":"Events_appContainer__F-VUT","mainGrid":"Events_mainGrid__vtRMM"};